import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Container from '../UI/Container';
import Whatsapp from '../Whatsapp/Whatsapp';
import { Logolight, youtube, linkedin } from './Assets';
import './Footer.css';
import type { RootState } from '../../Redux/Store';
import { logAnalyticsEvent } from '../../GoogeAnalytics';

const Footer = () => {
  const isMobile = useSelector((state: RootState) => state.mobileSlice.isMobile);

  return (
    <footer
      className="footer-container"
      id="bottom-footer"
    >
      <Container className={isMobile ? 'footer-mobile' : 'footer-data'}>
        <div className="left-container">
          <Link
            to="/"
            style={{ display: 'inline-block' }}
            onClick={() => {
              logAnalyticsEvent('button_click', {
                button_name: 'footer_logo',
                button_type: 'navigation',
                page_path: window.location.pathname,
              });
            }}
          >
            <img
              src={Logolight}
              alt="VisCommerce"
              width={243}
              height={60}
            />
          </Link>
        </div>
        <div className="right-container">
          <div style={{ flex: 1 }}>
            {/* <p className="link-start">Company</p> */}
            <p className="pointer">
              <Link
                to="/executive-brief"
                style={{ textDecoration: 'none', color: 'inherit' }}
                onClick={() => {
                  logAnalyticsEvent('button_click', {
                    button_name: 'footer_executive_brief',
                    button_type: 'navigation',
                    page_path: window.location.pathname,
                  });
                }}
              >
                Executive Brief
              </Link>
            </p>
            <p className="pointer">
              <Link
                to="/spaces365-platform"
                style={{ textDecoration: 'none', color: 'inherit' }}
                onClick={() => {
                  logAnalyticsEvent('button_click', {
                    button_name: 'footer_platform',
                    button_type: 'navigation',
                    page_path: window.location.pathname,
                  });
                }}
              >
                Platform
              </Link>
            </p>
            <p className="pointer">
              <Link
                to="/pricing"
                style={{ textDecoration: 'none', color: 'inherit' }}
                onClick={() => {
                  logAnalyticsEvent('button_click', {
                    button_name: 'footer_pricing',
                    button_type: 'navigation',
                    page_path: window.location.pathname,
                  });
                }}
              >
                Pricing
              </Link>
            </p>
            <p className="pointer">
              <Link
                to="/team"
                style={{ textDecoration: 'none', color: 'inherit' }}
                onClick={() => {
                  logAnalyticsEvent('button_click', {
                    button_name: 'footer_team',
                    button_type: 'navigation',
                    page_path: window.location.pathname,
                  });
                }}
              >
                Team
              </Link>
            </p>
            {/* <p className="pointer">Patent pending with USPTO, IPO</p> */}
          </div>
          {/* <div style={{ flex: 1 }}>
            <p className="link-start">Resources</p>
            <p>
              <a
                href="mailto:info@viscommerce.com"
                className="footer-links"
                onClick={() => {
                  logAnalyticsEvent('button_click', {
                    button_name: 'footer_support_email',
                    button_type: 'contact',
                    page_path: window.location.pathname,
                  });
                }}
              >
                Support
              </a>
            </p>
            <p className="pointer">Terms & Privacy</p>
            <p className="pointer">Cookie settings</p>
          </div> */}
          <div style={{ flex: 1 }}>
            <p className="link-start">Contact Us</p>
            <p>
              <a
                href="mailto:info@viscommerce.com"
                className="footer-links"
                onClick={() => {
                  logAnalyticsEvent('button_click', {
                    button_name: 'footer_contact_email',
                    button_type: 'contact',
                    page_path: window.location.pathname,
                  });
                }}
              >
                info@viscommerce.com
              </a>
            </p>
            <p className="pointer">
              2108 N St STE 200, Sacramento, California 95816, USA
            </p>
          </div>
        </div>
      </Container>
      <div className="footer-container-bottom">
        <Container className="footer-btm-data">
          <div>
            <p>Copyright © {new Date().getFullYear()} VisCommerce. All rights reserved.</p>
          </div>
          <div className="icon-container-footer">
            <a
              href="https://www.youtube.com/@viscommerce6098"
              target="_blank"
              rel="noreferrer"
              aria-label="YouTube"
              onClick={() => {
                logAnalyticsEvent('button_click', {
                  button_name: 'footer_youtube',
                  button_type: 'social',
                  page_path: window.location.pathname,
                });
              }}
            >
              <img
                src={youtube}
                alt="YouTube"
                width={25}
                height={25}
              />
            </a>
            <a
              href="https://www.linkedin.com/company/viscommerce-in/about/"
              target="_blank"
              rel="noreferrer"
              aria-label="LinkedIn"
              onClick={() => {
                logAnalyticsEvent('button_click', {
                  button_name: 'footer_linkedin',
                  button_type: 'social',
                  page_path: window.location.pathname,
                });
              }}
            >
              <img
                src={linkedin}
                alt="LinkedIn"
                width={25}
                height={25}
              />
            </a>
            <Whatsapp />
          </div>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;
